import { useLayoutEffect, useRef } from 'react';

import { createActionsHook } from 'react-sweet-state';

import { chatStore } from './chatStore';
import { initializeChatStore } from './initializeChatStore';
import { updateChatStoreSite } from './updateChatStoreSite';

const useInitializationActions = createActionsHook(chatStore);

export const ChatStoreInitializer = ({ siteId }: { siteId: string | undefined }): null => {
	const { runContainerAction } = useInitializationActions();
	const initializedScope = useRef<{
		siteId: string | undefined;
		runContainerAction: typeof runContainerAction;
	} | null>(null);

	useLayoutEffect(() => {
		const previous = initializedScope.current;
		if (previous === null || previous.runContainerAction !== runContainerAction) {
			initializedScope.current = { siteId, runContainerAction };
			void runContainerAction(initializeChatStore());
		} else if (previous.siteId !== siteId) {
			initializedScope.current = { siteId, runContainerAction };
			void runContainerAction(updateChatStoreSite());
		}
	}, [runContainerAction, siteId]);

	return null;
};
